import {
    RiArticleFill,
    RiBook2Fill,
    RiVideoFill,
    RiYoutubeFill,
    RiWebcamFill,
    RiFlaskFill,
    RiEditFill,
    RiWindow2Fill,
    RiTerminalBoxFill,
    RiSlideshow2Fill,
} from 'react-icons/ri';
import { MdSchool, MdAssignment } from 'react-icons/md';
import { SiWikipedia } from 'react-icons/si';

export const mediaTypes = [
    { id: 1, name: 'Article', icon: <RiArticleFill /> },
    { id: 2, name: 'Book', icon: <RiBook2Fill /> },
    { id: 3, name: 'Video', icon: <RiVideoFill /> },
    { id: 4, name: 'YouTube', icon: <RiYoutubeFill /> },
    { id: 5, name: 'Course', icon: <MdSchool /> },
    { id: 6, name: 'Exercise', icon: <MdAssignment /> },
    { id: 7, name: 'Webinar', icon: <RiWebcamFill /> },
    { id: 8, name: 'Interactive', icon: <RiFlaskFill /> },
    { id: 9, name: 'Note', icon: <RiEditFill /> },
    { id: 10, name: 'Wiki', icon: <SiWikipedia /> },
    { id: 11, name: 'Website', icon: <RiWindow2Fill /> },
    { id: 12, name: 'Code', icon: <RiTerminalBoxFill /> },
    { id: 13, name: 'Slide', icon: <RiSlideshow2Fill /> },
    { id: 14, name: 'Thesis', icon: <RiArticleFill /> },
];